import { render } from "./SpaAddonGarden.vue?vue&type=template&id=52da62ac&scoped=true"
import script from "./SpaAddonGarden.vue?vue&type=script&lang=js"
export * from "./SpaAddonGarden.vue?vue&type=script&lang=js"

import "./SpaAddonGarden.vue?vue&type=style&index=0&id=52da62ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52da62ac"]])

export default __exports__